var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastbackgroundcheckAddressesScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.fastbackgroundcheck{fill:url(#fastbackgroundcheck-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fastbackgroundcheck-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90c2e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#4e90c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e52c7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fastbackgroundcheck",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M68.71429,35.35632l-16.9198-7.6947c-1.14014-.51855-2.44885-.51855-3.58899,0l-16.9198,7.6947c-1.55676.70795-2.54785,2.25989-2.54102,3.97009.02887,7.22278,1.86188,26.13525,19.6131,33.22241,1.05243.42017,2.23199.42017,3.28442,0,17.75122-7.08716,19.58423-25.99963,19.6131-33.22241.00684-1.71021-.98425-3.26215-2.54102-3.97009ZM52.68445,61.71259c-1.3739,1.72705-3.99493,1.72705-5.36884,0-3.08282-3.87543-7.72034-10.34265-7.72034-14.17902,0-5.7464,4.65839-10.40479,10.40479-10.40479s10.40472,4.65839,10.40472,10.40479c0,3.83636-4.63745,10.30359-7.72034,14.17902Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 50.00006,
    cy: 47.53357,
    r: 4.22693
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastbackgroundcheckAddressesScraper);
export default __webpack_public_path__ + "static/media/fastbackgroundcheck-addresses-scraper.a97b00e737c2eb8efe81eebd87385cfc.svg";
export { ForwardRef as ReactComponent };